import { Provider } from "@angular/core";
import { ChildApiToken, ChildrenApiService } from "./services/children-api.service";

export const ChildProviders: Provider[] = [
  {
    provide: ChildApiToken,
    useExisting: ChildrenApiService
  }
];
